import { GTM_STRING } from '../constants';

const checkForGTM = (components = []) =>
  !!components.find(({ type, items }) => {
    if (type && type.includes(GTM_STRING)) return true;
    if (items && items.length) return checkForGTM(items);
    return false;
  });

export default checkForGTM;
